import React from 'react';
import cn from 'classnames';
import { Avatar, getFaIcon } from '@odin-labs/components';
import { LandmarkIcon, MapMarkerAltIcon, faBriefcase } from 'components/icons';

const BriefcaseIcon = getFaIcon({
  icon: faBriefcase,
  className: cn('odin-text-odin-primary'),
});

export const classes = {
  titleSkeleton: cn(
    'odin-text-transparent odin-text-2xl',
    'odin-animate-pulse odin-bg-gray-300 odin-rounded-md -odin-ml-1',
  ),
};

export function JobsiteTitle({
  name,
  addressCity,
  addressState,
  organizationName,
  profileImageUrl,
}: {
  name: string;
  addressCity?: string;
  addressState?: string;
  organizationName?: string;
  profileImageUrl?: string;
}): React.ReactElement {
  const locationString = [addressCity, addressState].filter(Boolean).join(', ');
  return (
    <div className="odin-flex odin-gap-x-8">
      <Avatar
        src={profileImageUrl}
        icon={profileImageUrl ? undefined : BriefcaseIcon}
        type="rounded"
        objectFit="cover"
        size="2xl"
      />
      <div className="odin-flex odin-flex-col odin-justify-around">
        <h1 className="odin-text-xl odin-font-bold odin-text-odin-black sm:odin-text-2xl sm:odin-truncate">
          {name ?? (
            <span className={classes.titleSkeleton}>
              Loading Contractor Data
            </span>
          )}
        </h1>
        <div className="odin-flex odin-items-center odin-gap-x-4">
          {locationString && (
            <span className="odin-text-sm">
              <MapMarkerAltIcon className="odin-text-base odin-text-odin-primary odin-mr-2" />
              {locationString}
            </span>
          )}
          {organizationName && (
            <span className="odin-text-sm">
              <LandmarkIcon className="odin-text-base odin-text-odin-primary odin-mr-2" />
              {organizationName}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
